<div class="w-100 h-100 basket-main mt-100px">
  <div class="basket-icon-main">
    <img src="assets/cart/basketImage.svg" alt="Basket icon" class="basket-icon">
  </div>
  <div class="basket-empty-text">
    <h2 class="basket-text">{{'cart.cart_empty' | translate }}</h2>
    <button class="basket-button" [routerLink]="['/products']">{{'cart.continue_shopping' | translate }}</button>
  </div>
</div>
